export const sortByCreatedAt = (a: { createdAt?: string }, b: { createdAt?: string }) => {
  const aCreatedAt = a.createdAt ?? '';
  const bCreatedAt = b.createdAt ?? '';
  if (aCreatedAt < bCreatedAt) return -1;
  if (aCreatedAt > bCreatedAt) return 1;
  return 0;
};

export const sortByCreatedAtDescending = (a: { createdAt?: string }, b: { createdAt?: string }) => {
  return sortByCreatedAt(a, b) * -1;
};

export const sortByUpdatedAtDescending = (
  a: { updatedAt: string; matchedAt?: string },
  b: { updatedAt: string; matchedAt?: string }
) => {
  const aTime = a.matchedAt || a.updatedAt;
  const bTime = b.matchedAt || b.updatedAt;

  if (aTime < bTime) return 1;
  if (aTime > bTime) return -1;
  return 0;
};
